import React from "react";

// @mui
import { styled } from '@mui/material/styles';

// component
import functionlist from '../../../image/img_funclist.png'

export default function FreePlan( { data } ) {

  // css -------------------------------------------------------------


  const Div = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding : 80,
    backgroundColor: theme.palette.background.default,
  }));

  const LI = styled('li')(() => ({
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    marginTop:'10px'
  }));

  // -------------------------------------------------------------

  return (
    <>
        
          <div style={{display :'flex'}}><p style={{ color : "rgb(26 158 248)" }}>접속 계정&nbsp;&nbsp;</p><p>{data}</p></div>
          <p style={{fontSize :'x-large', fontWeight : '700', marginTop: 30, marginBottom:10}}>프로 플랜(Pro Plan)</p>
          <p>기공소를 더욱 더 발전시켜보세요. 표준 기능에 고급 기능까지</p>
          <div style={{marginTop: 30}}>
            <span style={{fontWeight : '900', fontSize :'large'}}>주요기능</span>
            <div style={{marginTop: 10}}>
                <div>
                    <ul>
                        <LI><img src={functionlist} alt='functionlist'/><p style={{ paddingLeft:'5px' }}>접수 무제한</p></LI>
                        <LI><img src={functionlist} alt='functionlist'/><p style={{ paddingLeft:'5px' }}>청구서 발행 무제한</p></LI>
                        <LI><img src={functionlist} alt='functionlist'/><p style={{ paddingLeft:'5px' }}>거래처 등록 무제한</p></LI>
                        <LI><img src={functionlist} alt='functionlist'/><p style={{ paddingLeft:'5px' }}>구성원 권한 설정 및 등록 무제한</p></LI>
                        <LI><img src={functionlist} alt='functionlist'/><p style={{ paddingLeft:'5px' }}>데이터베이스 자동 백업</p></LI>
                        <LI><img src={functionlist} alt='functionlist'/><p style={{ paddingLeft:'5px' }}>월별/파트별 매출 통계 제공</p></LI>
                    </ul>
                    
                </div>
            </div>
          </div>
        
    </>
  );
}
